import React, { Component, Fragment } from "react";
import { CCheckbox } from "@appcues/component-library";
import SelectFlow from "components/Common/SelectFlow";

class ContentTriggering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forceShowNextStep: false
    };
  }

  render() {
    const { rule, setNextStepId } = this.props;

    const showNextStep = this.state.forceShowNextStep || !!rule.nextContentId;

    return (
      <Fragment>
        <CCheckbox
          onClick={() => {
            if (showNextStep) {
              setNextStepId(rule.id, null);
              this.setState({
                forceShowNextStep: false
              });
            } else {
              this.setState({
                forceShowNextStep: true
              });
            }
          }}
          label={"Trigger Appcues content"}
          checked={showNextStep}
        />
        {(() => {
          if (showNextStep) {
            return (
              <div className="content">
                <SelectFlow
                  value={rule.nextContentId}
                  stepFilter={step => !step.parentId}
                  onChange={value => {
                    setNextStepId(rule.id, value);
                  }}
                />
              </div>
            );
          }
          return null;
        })()}
      </Fragment>
    );
  }
}

export default ContentTriggering;
